// extracted by mini-css-extract-plugin
export var actionButton = "_pp-0";
export var actionMenuContainer = "_pp-i";
export var bubble = "_pp-2";
export var bubbleActionMenu = "_pp-j";
export var bubbleContext = "_pp-6";
export var bubbleItems = "_pp-7";
export var customer = "_pp-3";
export var divider = "_pp-8";
export var fileList = "_pp-9";
export var hiddenComment = "_pp-o";
export var infoAbove = "_pp-a";
export var internal = "_pp-4";
export var lightActionButton = "_pp-1";
export var link = "_pp-b";
export var merchant = "_pp-5";
export var message = "_pp-c";
export var profilePicture = "_pp-e";
export var quillToolbarContainer = "_pp-f";
export var senderDate = "_pp-g";
export var senderDateCustomer = "_pp-h";
export var senderName = "_pp-d";
export var time = "_pp-k";
export var uploadedImage = "_pp-l";
export var username = "_pp-m";
export var xsmall = "_pp-n";